module.exports = __webpack_public_path__ + "static/media/bank-acc-icon.f97b5c8b.svg";